<template>

  <div class="multiSelectPicker">
    <overlay-anchor :anchor="anchor" :directions="directions" @positioned="updatePosition">

      <div class="overlay"
           :style="{
             'max-width': (windowDimmensions.width- position.x - 5)+'px',
             'max-height': (windowDimmensions.height- position.y - 5)+'px'
           }">
        <ul class="">
          <li class="" v-for="(option, index) in visibleOptions"
              v-on:click="set(option)">

            <span >{{ display(option) }}</span>

          </li>
        </ul>
      </div>
    </overlay-anchor>
  </div>

</template>

<script>

  import { windowDimmensions, OverlayAnchor } from "./overlayLayer.js"
  import overlayModel from "./overlayModel.js"

  var uniqCounter = 0
  var focusLostListener = null

  export default {
    name: 'single-select-picker',
    components: { OverlayAnchor },
    props: {
      options: {
        type: Array
      },
      value: {},
      anchor: {},
      display: {
        type: Function,
        default: (x)=>x.title || x
      }
    },
    data () {
      return {
        directions: [{ x:1, y:1, ax: -1, ay: 1}, { x:1, y:-1, ax: -1, ay: -1}],
        uniq: "" + (uniqCounter++),
        liveValue: this.value,
        position: {x:0, y:0}
      }
    },
    computed: {
      windowDimmensions() { return windowDimmensions },
      visibleOptions() {
        let options = this.options.slice()
        return options
      }
    },
    watch: {
      value(q) {
        this.liveValue = q
      }
    },
    methods: {
      set(option) {
        this.liveValue = option
        this.$emit("input", this.liveValue)
      },
      updatePosition(position) {
        this.position.x = position.x
        this.position.y = position.y
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .overlay {
    width: 50vw;
    pointer-events: none;
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-family: "Helvetica","Arial",sans-serif;
    color: rgba(0,0,0,.57);
    width: 100vw;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    min-width: 200px;
    pointer-events: all;
    /* max-height: 30vh;*/
    width: auto;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
    background: white;
    z-index: 2;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
    padding-left: 6px;
    padding-right: 6px;
  }

  li {
    padding-top: 4px;
    padding-bottom: 4px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    flex-shrink: 0;
  }

  li:hover {
    color: black;
  }

</style>



// WEBPACK FOOTER //
// SingleSelectPicker.vue?9f388912